import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Fr_Input from "../../lib/ui/fr_input";
import Fr_Cal from "../../lib/ui/fr_cal";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Bo_Prm extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
      this.state.aa = [];
      this.state.wfp = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.fak_prm();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 480;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

    fak_prm() {
        var self = this;
        var prm = {};
        prm.req = "fakt.fakt_prm.prm";
        prm.faknr = this.state.faknr;
        prm.faktnr = this.state.faknr;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rco));

                self.setState({ wfp: ret.wfp });
                //self.syncTb("fakTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    fak_prm_save() {
        var self = this;

        var wfp = this.state.wfp;

        var prm = {};
        prm.req = "fakt.fakt_prm.prm_save";
        prm.wfp = this.state.wfp;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    val_save(id, val) {
        var wfp = this.state.wfp;
        //var id1 = id.split(".")[0];
        //var id2 = id.split(".")[1];
        //wfh[id1][id2] = val;
        wfp[id] = val;
        this.setState({ wfp: wfp });
        return;
    }

  render() {
    return (
        <div className="web-app">

            <div className="flex-row">
                <div className="label_h03">Parametrar</div>
                <div className="flex"></div>
                <button className="btn btn-hw-orange w150" onClick={() => this.fak_prm_save() } aria-label="System" >
                    Spara
                </button>
                <button className="btn btn-hw-blue w150" onClick={() => this.fak_prm() } aria-label="System" >
                    Visa
                </button>
            </div>
            <div className="divider_green"></div>

            <form className="cdi_f03">
                <div className="flex-row">
                    <Fr_Input label="Bas avd" className="text-left w250" text={this.state.wfp.basavd} getValue={(e)=> this.val_save("basavd", e) } />
                    <Fr_Input label="Betal dagar" className="text-left w250" text={this.state.wfp.betvillkor} getValue={(e)=> this.val_save("betvillkor", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Huvud" className="text-left w250" text={this.state.wfp.fakthuvud} getValue={(e)=> this.val_save("fakthuvud", e) } />
                    <Fr_Input label="Faktnr" className="text-left w250" text={this.state.wfp.startfaktnr} getValue={(e)=> this.val_save("startfaktnr", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Standard" className="text-left w250" text={this.state.wfp.faktstandard} getValue={(e)=> this.val_save("faktstandard", e) } />
                    <Fr_Input label="Transaktion" className="text-left w250" text={this.state.wfp.bastransfakt} getValue={(e)=> this.val_save("bastransfakt", e) } />
                </div>
                <div className="divider_green"></div>
                <div className="flex-row hide">
                    <Fr_Input label="Faktura avgift" className="text-left w250" text={this.state.wfp.faktbelopp} getValue={(e)=> this.val_save("faktbelopp", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Betvillkor" className="text-left w350" text={this.state.wfp.Betvillkor_txt} getValue={(e)=> this.val_save("Betvillkor_txt", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="F-Skatt" className="text-left w350" text={this.state.wfp.F_skattnr_txt} getValue={(e)=> this.val_save("F_skattnr_txt", e) } />
                </div>

            </form>
    </div>
  );
    }
}
export default Bo_Prm;
